/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-02-20 20:35:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-24 18:53:49
 */
const loader = (name: string) => async () => {
  const entrance = await import(/* webpackChunkName: "f.admin" */ './');
  return entrance[name];
};

import { IRoute } from '@src/types';

export const childRoutes: IRoute[] = [
  {
    load: loader('SFCArtListPage'),
    path: 'artList'
  },
  {
    load: loader('GroupListPage'),
    path: 'groupList'
  },
  {
    load: loader('MallPage'),
    path: 'mallList'
  },
  {
    load: loader('AdminPage'),
    path: 'admin'
  },
  {
    load: loader('MallOrderListPage'),
    path: 'orderList'
  },
  {
    load: loader('BannerListPage'),
    path: 'bannerList/:tabKey'
  },
  {
    load: loader('ThematicListPage'),
    path: 'thematicList'
  }
];
export default {
  path: 'admin',
  name: 'admin',
  childRoutes
};
